import { useTranslation } from '@mntn-dev/i18n'
import { Text } from '@mntn-dev/ui-components'

import { useStore } from '~/store/index.ts'

export const EmptyPlaceholder = () => {
  const { lng } = useStore()
  const { t } = useTranslation(lng, 'generic')

  return (
    <div className="w-full h-full">
      <Text
        className="h-full content-center text-center"
        as="div"
        textColor="tertiary"
      >
        {t('nothing-to-see')}
      </Text>
    </div>
  )
}
